export default "__VITE_ASSET__D3TSM6fm__"